import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { AuthGuard } from './Services/auth_guard/auth_guard.service';
import { environment } from 'src/environments/environment';



const routes: Routes = [

  // Home 1 Path
  {
    path: "",
    loadChildren: () => import("./Lazy-loaded-Modules/Home-Modules/home/home.module").then(m => m.HomeModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
  {
    path: "",
    loadChildren: () => import("./Lazy-loaded-Modules/Product-Modules/product-listing/product-listing.module").then(m => m.ProductListingModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
  {
    path: "login",
    loadChildren: () => import("./Lazy-loaded-Modules/Account-Modules/login/login.module").then(m => m.LoginModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
  {
    path: "",
    loadChildren: () => import("./Lazy-loaded-Modules/Product-Modules/Product-details/Product-Details.module").then(m => m.ProductDetailsModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },




  {
    path: "",
    loadChildren: () => import("./Lazy-loaded-Modules/Shop-Modules/Shop-Listing/shop-listing.module").then(m => m.ShopListingModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
  {
    path: "not-found",
    loadChildren: () => import("./Component/Common/pagenotfound/pagenotfound.module").then(m => m.PagenotfoundModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
  {
    path: "",
    loadChildren: () => import("./Lazy-loaded-Modules/Cart-Module/cart-page/cart-page.module").then(m => m.CartPageModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
  {
    path: "my-account",
    loadChildren: () => import('./Lazy-loaded-Modules/Account-Modules/my-account/my-account.module').then(m => m.MyAccountModule),
    data: {name: "default", roles: ["all"]},
    canActivate: [AuthGuard],
  },
  {
    path: 'my-orders',
    data: {name: 'default', roles: ['all']},
    canActivate: [AuthGuard],
    loadChildren: () => import('./Lazy-loaded-Modules/Order-Modules/my-orders/my-orders.module').then(m => m.MyOrdersModule)
  },
  {
    path: 'my-order-details/:id', 
    data: {name: 'default', roles: ['all']}, 
    canActivate: [AuthGuard],
    loadChildren: () => import('./Lazy-loaded-Modules/Order-Modules/my-order-details/my-order-details.module').then(m => m.MyOrderDetailsModule)
  },
{
    path: 'about-us',
    data: {name: 'default', roles: ['all']},
    loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/about-us/about-us.module').then(m => m.AboutUsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'contact-us',
    data: {name: 'default', roles: ['all']},
    loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/contact-us/contact-us.module').then(m => m.ContactUsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cancellation-policy',
    data: {name: 'default', roles: ['all']},
    loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/cancellation-policy/cancellaion-policy.module').then(m => m.CancellationPolicyModule),
  },
  {
    path: "FAQs",
    data: { name: "default", roles: ['all']},
    loadChildren: () => import("./Lazy-loaded-Modules/Static-Pages/faqs/faqs.module").then(m => m.FaqsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'privacy-policy',
    data: {name: 'default', roles: ['all']},
    loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'return-policy',
    data: {name: 'default', roles: ['all']},
    loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/return-policy/return-policy.module').then(m => m.ReturnPolicyModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'shipping-and-delivery',
    data: {name: 'default', roles: ['all']},
    loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/shipping-delivery/shipping-delivery.module').then(m => m.ShippingDeliveryModule),
    canActivate: [AuthGuard]
  },
  {
    path: "checkout",
    loadChildren: () => import("./Lazy-loaded-Modules/Checkout/checkout.module").then(m => m.CheckoutModule),
    data: { name: 'default', roles: ['all'] },
    canActivate: [AuthGuard]
  },
   {
      path: '',
      data: {name: 'default', roles: ['all']},
      loadChildren: () => import('./Lazy-loaded-Modules/Static-Pages/terms-and-condition/terms-and-condition.module').then(m => m.TermsAndConditionModule),
      canActivate: [AuthGuard]
    }
 

];



@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [Injector],
      multi: true
    }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }


export function initApp(injector: Injector) {
  return () => {
    return new Promise<void>((resolve) => {
      const orgId = environment.orgId;
      const filteredRoutes = routes.filter((r: any) => {
        return r.data.roles.indexOf('all') !== -1 || r.data.roles.indexOf(orgId) !== -1;
      });
      const router: Router = injector.get(Router);
      router.resetConfig(filteredRoutes);
      resolve();
    });
  };
}
